import React from 'react'
import './SkeletonScreenOrderTracking.scss'
import Skeleton from '@material-ui/lab/Skeleton';

const  SkeletonScreenOrderTracking = () => {
  return (
    <div className='expandedTiles-skeleton'>
        <div className='expandedTiles-skeleton-status'>
            <Skeleton variant="rect" width={29} height={21} />
            <Skeleton variant="rect" width={259} height={27} />
        </div>
        <div className='expandedTiles-skeleton-delivery'>
          <Skeleton variant="rect" width={311} height={21} />
          <Skeleton variant="rect" width={295} height={21} />
          <Skeleton variant="rect" width={156} height={36} />
        </div>

        <div className='expandedTiles-skeleton--order-status'>
            {
                [1,2,3,4].map((i)=>{
                    return (
                        <>
                            <Skeleton variant="circle" width={24} height={22} />
                            {i <4 ?
                            <Skeleton variant='text' width={70} height={2} />:''
                        }

                        </>
                        )
                    })
                }
        </div>

        <div className='expandedTiles-skeleton--order-status-info'>     
            {  
                [1,2,3,4].map((i)=>{
                    return (
                        <>
                            <Skeleton variant="rect" width={80} height={21} />
                        </> 
                    )
                })
            }
                
        </div>

        <div className='expandedTiles-skeleton--order-details-'>
            {
                [1,2,3].map((i)=>{
                    return (
                        <div className='expandedTiles-skeleton--product-details'>
                            <div className='expandedTiles-skeleton--product-details-img'>
                                <Skeleton variant="rect" width={68} height={60} />
                            </div>
                            <div className="expandedTiles-skeleton--product-details-name">
                                <Skeleton variant="rect" width={249} height={21} />
                                <Skeleton variant="rect" width={61} height={21} />
                            </div>
                        </div>
                    )
                })
            }
        </div>

        <div className='expandedTiles-skeleton--button'>
            <Skeleton variant='rect' width={327} height={49}/>
        </div>
                
    </div>
    )
}

export default SkeletonScreenOrderTracking;
